<template>
  <div class="dialog" v-show="visible" :class="{ fade }">
    <div class="wrapper" :class="{ fade }">
      <div class="header">
        <h3>{{ title }}</h3>
        <a @click="closeDialog" href="javaScript:;" class="iconfont icon-close-new"></a>
      </div>
      <div class="body">
        <slot />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
export default {
  name: 'DialogComponent',
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const fade = ref(false)

    watch(
      () => props.visible,
      newVal => {
        setTimeout(() => {
          fade.value = newVal
        }, 0)
      },
      { immediate: true }
    )

    const closeDialog = () => {
      emit('resetForm')
      emit('update:visible', false)
    }

    return { fade, closeDialog }
  }
}
</script>

<style scoped lang="less">
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 8887;
  background: rgba(0, 0, 0, 0);
  &.fade {
    transition: all 0.4s;
    background: rgba(0, 0, 0, 0.5);
  }
  .wrapper {
    width: 532px;
    // height: 480px;
    background: #f7f7f7;
    border-radius: 6px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    overflow: hidden;
    opacity: 0;
    &.fade {
      transition: all 0.4s;
      transform: translate(-50%, -50%);
      opacity: 1;
    }
    .body {
      padding: 20px 40px;
      font-size: 16px;
      .icon-warning {
        color: @priceColor;
        margin-right: 3px;
        font-size: 16px;
      }
    }
    .footer {
      text-align: center;
      padding: 10px 0 30px 0;
    }
    .header {
      position: relative;
      height: 68px;
      line-height: 68px;
      text-align: center;
      background: @themeColor;
      color: #fff;
      h3 {
        font-weight: normal;
        font-size: 18px;
      }
      a {
        position: absolute;
        right: 25px;
        top: 25px;
        font-size: 18px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        &:hover {
          color: #dedede;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .dialog {
    .wrapper {
      width: 92%;
      // height: 320px;
      .header {
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        h3 {
          font-size: 16px;
        }
        a {
          top: 50%;
          right: 15px;
          font-size: 16px;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
